export function renderDate(timestamp) {
  const date = new Date(timestamp*1000);

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}


export function renderCreds(creds) {
  if (!creds || creds <= 0) {
    return '0'
  }
  return ((creds * 100) || 0).toFixed(1) 
}